import Contacto from '@componentes/Contacto/Contacto';
import './index.css'

export default function EnlacesSuperior() {
    return (
        <div className='enlaces-superior-main'>
            <div className='enlaces-superior'>
                <Contacto />
            </div>
        </div>
    );
}